import { webAPI } from '../../../axiosInstance';


const getOneOrder = async (data: any) => {
  const response = await webAPI.get(`/orders/${data.orderId}`);
  return response.data;
};


const editOrderStatus = async (data: any) => {
  console.log('data', data)
  const response = await webAPI.patch(`/orders/edit/${data.orderId}/order-status`, {
    status: data.orderStatusId,
  });
  return response.data;
};

export { getOneOrder, editOrderStatus };
